import React, {useRef} from 'react';
import {useNavigate} from "react-router-dom";
import styles from './unsubPopup.module.css';
import Routes from "../../assets/RoutesToPages/Routes";

const UnsubPopup = ({isShown, handleShow}) => {
  const navigate = useNavigate();
  const unsubMessageClose = useRef(null);
  const message = useRef(null);


  const handleVisibilityMessage = () => {
    if (message.current && isShown) {
      handleShow(false);
      navigate(Routes.unsubscription);
    }
  };


  return (
    <div ref={message}
         className={`${styles.message} ${isShown ? styles.show : ''}`}>
      <div className={styles.messageContent}>
        <button ref={unsubMessageClose}
                className={styles.formClose}
                onClick={handleVisibilityMessage}
                type="button">
          close
        </button>
        <p className={styles.messageText}>
          Niečo sa pokazilo, skúste to prosím znova
        </p>
      </div>
    </div>
  )
}

export default UnsubPopup;